import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Layout from "../../../layout";
import TitlePage from '../../common/TitlePage';
import { Box } from '@material-ui/core'
import { convertNumberToPersian } from "../../method/convertDigitToEnglish";


const useStyles = makeStyles((theme) => ({
    root: {
        height: '60vh',
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },

    details: {
        width: '50%',
        margin: 'auto',
        borderRadius: 15,
        boxShadow: `0px 0px 36px rgba(0, 0, 0, 0.161)`,
        padding: "20px 27px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        [theme.breakpoints.down('sm')]: {
            width: "98%",
        }

    },
    item: {
        display: "flex",
        alignItems: "center",
        flexDirection: 'column',
        color: "black",
        fontSize: "1rem",
        fontWeight: 'bold',
        "& > div": {
            width: "100%",
            textAlign: 'center'
        },

    },
    color: {
        color: theme.palette.light.type2
    },

}));

export default function Index() {

    const classes = useStyles()

    return (
        <Layout>
            <div className={classes['root']}>
            <div className={classes.details}>
                <Box className={classes.item}>
                    <TitlePage position="bottomCenter" padding="20px 27px">
                           راه‌های ارتباطی با کارگزاری <span className={classes.color}>پویان</span>
                    </TitlePage>
                    <hr style={{ width: '100%' }} />
                    <p>
                        <span>ایمیل : </span>
                        <span>info@pouyanbroker.ir</span>
                    </p>
                    {/*<p>*/}
                    {/*    <span>مرکز تماس : </span>*/}
                    {/*    <span>{convertNumberToPersian(`81021850-021`)}</span>*/}
                    {/*</p>*/}

                    <p>
                        <span>پشتیبانی : </span>
                        <span>{convertNumberToPersian(`91005777-021`)}</span>
                    </p>
                </Box>
            </div>
            </div>
        </Layout>
    );
}

